import { TrialBalanceReportRequestModel } from '../api/models/TrialBalanceReportRequestModel';
import { TrialBalanceReportFormModel } from '../models';

export const dataFormToRequest = (
  data: TrialBalanceReportFormModel
): TrialBalanceReportRequestModel => ({
  date: data.date,
  detailed: data.detailed,
  file_type: data?.file_type,
});
